import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'helpers/api';
import * as mapYourMedsConstant from '../../../common/mapYourMedsConstant.js';

const HoldReasonForm = (props) => {
    const initialFormData = {
        holdreason: "",
        isactive: true,
        id: ""
    };

    const [formData, setFormData] = useState(initialFormData);
    const [buttonStatus, setButtonStatus] = useState(mapYourMedsConstant.ADD_ACTION);
    const formRef = useRef(null);

    useEffect(() => {
        const val = props.holdreasonvalue;
        if (val) {
            if (typeof val === 'object') {
                const id = val.id || val.reason_id || val.holdreason_id || "";
                const reason = val.reason || val.holdreason || "";
                const isActive = val.is_active == 1 || val.is_active === '1' || val.is_active === true;
                if (id) {
                    setFormData({
                        holdreason: reason,
                        isactive: isActive,
                        id: id
                    });
                    setButtonStatus(mapYourMedsConstant.UPDATE_ACTION);
                    return;
                }
            } else if (typeof val === 'string' && val.includes(',')) {
                const parts = val.split(',');
                if (parts.length >= 3 && parts[2]) {
                    setFormData({
                        holdreason: parts[0] || "",
                        isactive: parts[1] == 1 || parts[1] === '1' || parts[1] === 'true',
                        id: parts[2] || ""
                    });
                    setButtonStatus(mapYourMedsConstant.UPDATE_ACTION);
                    return;
                }
            }
        }
        setFormData(initialFormData);
        setButtonStatus(mapYourMedsConstant.ADD_ACTION);
    }, [props.edittrigger, props.holdreasonvalue]);

    const isAddMode = buttonStatus === "Add" || buttonStatus === mapYourMedsConstant.ADD_ACTION;

    const handleSubmit = async e => {
        e.preventDefault();

        let tokenStr = localStorage.getItem("accessToken");

        let holdReasonUrl = isAddMode ? `${process.env.REACT_APP_SERVER_URL}/drugs/add-hold-reason/` : `${process.env.REACT_APP_SERVER_URL}/drugs/update-hold-reason/`;

        let holdReasonData = isAddMode ? 
            { "reason": formData.holdreason, "group_id": localStorage.getItem("groupId") || '', "is_active": 1 } : 
            { "reason": formData.holdreason, "group_id": localStorage.getItem("groupId") || '', "is_active": formData.isactive ? 1 : 0, "reason_id": formData.id };

        try {
            const { data } = await axios.post(holdReasonUrl, holdReasonData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

            if (data.status) {
                toast.success(isAddMode ? "Reason added successfully" : "Reason updated successfully");
            } else {
                toast.info("Error while adding/updating Reason");
            }
        } catch (error) {
            toast.error("Failed to save Hold Reason");
        }

        setFormData(initialFormData);
        if (formRef.current) formRef.current.reset();
        setButtonStatus("Add");

        if (props.onCallParent) {
            props.onCallParent();
        }
    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Form ref={formRef} onSubmit={handleSubmit}>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">Reason</Form.Label>
                        <Form.Control
                            placeholder='Reason'
                            value={formData.holdreason}
                            name="holdreason"
                            onChange={handleFieldChange}
                            type="text"
                            size="sm"
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group>
                        <Button
                            type="submit"
                            color="primary"
                            className="w-50 mt-4"
                            disabled={!formData.holdreason || !formData.holdreason.trim()}
                            size="sm"
                        >
                            {buttonStatus}
                        </Button>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <Form.Group>
                        <Form.Check
                            type='switch'
                            name="isactive"
                            id='isactive'
                            checked={isAddMode ? true : formData.isactive}
                            disabled={isAddMode}
                            onChange={e =>
                                setFormData({
                                    ...formData,
                                    isactive: e.target.checked
                                })
                            }
                            label='Active'
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                </Col>
            </Row>
        </Form>
    );
};

HoldReasonForm.propTypes = {
    holdreasonvalue: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default HoldReasonForm;

